import getBG from '../../utils/utils';

export default {
    name: 'cloud-product',
    data() {
        return {
            products: [],
            backgroundImage: '',
            headerImage: ''
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            this.getCloudProduct();
            this.backgroundImage = await getBG.call(this, 'CloudProducts');
            this.headerImage = await getBG.call(this, 'Products');
        },
        // 查云产品
        getCloudProduct() {
            this.$http
                .fetchData('contentManage/getContentManageList', {
                    contentType: 'CloudProducts'
                })
                .then(res => {
                    this.products = res.map(item => {
                        item.image = this.$config.baseUrl + item.image;
                        return item;
                    });
                    console.log(res);
                })
                .catch(err => {
                    this.$message({
                        message: err,
                        type: 'error'
                    });
                });
        },
        go(path, item) {
            const { href } = this.$router.resolve({
                path: path,
                query: {
                    id: item.id,
                    purposeType: 'CloudProducts'
                }
            });

            window.open(href, '_blank');
        }
    }
};
